// AES 복호화 CryptoJS 라이브러리
import CryptoJS from 'crypto-js'
// Secret Key
const SECRET_KEY_B64 =
    process.env.MEMBER_SESSION_SECRET_KEY ||
    'UDlzNS9ReUQ3TDNzNHgyL044ZzFrUTZFdythQmNYL0c='
// IV 값
const IV_B64 =
    process.env.MEMBER_SESSION_IV ||
    'ZTByNnA5ZzFPMng1YzRtMw=='
// Base64 문자열을 CryptoJS가 사용할 수 있는 WordArray 형태로 변환
const KEY = CryptoJS.enc.Base64.parse(SECRET_KEY_B64)
const IV = CryptoJS.enc.Base64.parse(IV_B64)
// legacy Java Map 문자열을 객체로 변환하는 함수
function parseLegacyMapString(text = '') {
    const stripped = String(text).trim().replace(/^\{/, '').replace(/\}$/, '')

    if (!stripped) return null

    const result = {}

    stripped.split(/\s*,\s*/).forEach((pair) => {
        const index = pair.indexOf('=')

        if (index === -1) return

        const key = pair.slice(0, index).trim()
        const value = pair.slice(index + 1).trim()

        result[key] = value
    })

    return Object.keys(result).length ? result : null
}
// 서버에서 받은 암호화된 session payload를 복호화하는 함수
export function decryptSessionPayload(cipherText = '') {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, KEY, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        })

        const plainText = bytes.toString(CryptoJS.enc.Utf8)

        if (!plainText) return null

        try {
            return JSON.parse(plainText)
        } catch (e) {
            return parseLegacyMapString(plainText)
        }
    } catch (e) {
        console.error('decryptSessionPayload error', e)
        return null
    }
}